// extracted by css-extract-rspack-plugin
export default {"wrapper":"_d00f0dff","additionalSpacing":"_746c3214"};